import {Button, Input, Textarea,} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import SelectInput from "../../system/select";
import "../../../style/datePicker.css"
import {updateAgentRequestContactInfo} from "../../../services/agent/agent_request";
import {getProvinceCities} from "../../../services/city/city";
import {getProvinces} from "../../../services/province/province";
import Validator from "../../../helper/validator/Validator";
import {ValidatorProvider} from "../../../helper/validator/ValidatorContext";
import {checkAll} from "../../../helper/validator/Check";
import {AgentRequestContext} from "../../../context/agent_context";
import {toast} from "react-toastify";
import {
  agentRequestFieldClass,
  AgentRequestFieldLabel,
  agentRequestInputProps,
  agentRequestPrimaryButtonClass,
  agentRequestSecondaryButtonClass,
} from "./ui";

export function AgentRequestContactInfo() {

  const {
    agentRequest,
    setAgentRequest,
    handleNext,
    handlePrev,
    isFirstStep,
    isLastStep,
    allowedStep,
    setAllowedStep,
  } = useContext(AgentRequestContext)

  const [provinceId, setProvinceId] = useState(null)
  const [cityId, setCityId] = useState(null)

  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setProvinceId(agentRequest.province_id);
    setCityId(agentRequest.city_id);
  }, []);

  useEffect(() => {
    setAgentRequest((prev) => ({
      ...prev,
      province_id: provinceId,
    }));
  }, [provinceId]);

  useEffect(() => {
    setAgentRequest((prev) => ({
      ...prev,
      city_id: cityId,
    }));
  }, [cityId]);

  const save = async () => {
    const data = {
      id: agentRequest.id,
      province_id: parseInt(agentRequest.province_id),
      city_id: parseInt(agentRequest.city_id),
      home_phone: agentRequest.home_phone,
      email: agentRequest.email,
      address: agentRequest.address,
    };
    setIsChecked(true)
    const res = checkAll();
    if (!res) {
      toast.error("مقادیر الزامی را بر اساس راهنما تکمیل کنید")
      return
    }

    let result;

    result = await updateAgentRequestContactInfo(data);

    if (result.status === 200) {
      if (allowedStep === 1) {
        setAllowedStep(2)
      }
      handleNext(2);
    }

  };

  return (
    <ValidatorProvider>
      <>
        <div className="grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-2 xxl:grid-cols-3">

          <div className={agentRequestFieldClass}>
            <SelectInput
              className="w-full"
              stackedLabel
              label={Dict("province")}
              defaultValue={provinceId}
              autoLoadService={getProvinces}
              onChange={setProvinceId}
            />
            <Validator isChecked={isChecked} state={provinceId} rules="required"/>
          </div>
          <div className={agentRequestFieldClass}>
            <SelectInput
              className="w-full"
              stackedLabel
              label={Dict("city")}
              defaultValue={cityId}
              refreshSignal={provinceId}
              autoLoadService={getProvinceCities}
              autoLoadServiceData={provinceId}
              onChange={setCityId}
            />
            <Validator isChecked={isChecked} state={cityId} rules="required"/>
          </div>


          <div className={agentRequestFieldClass}>
            <AgentRequestFieldLabel htmlFor="agent-home-phone">{Dict('home_phone')}</AgentRequestFieldLabel>
            <Input {...agentRequestInputProps}
                   id="agent-home-phone"
                   value={agentRequest.home_phone}
                   placeholder={Dict('home_phone')}
                   onChange={(e) => {
                     setAgentRequest((prev) => ({
                       ...prev,
                       home_phone: e.target.value,
                     }));
                   }}
            />
            <div className="flex flex-row">
              <Validator isChecked={isChecked} state={agentRequest.home_phone} rules="required"/>
              <Validator isChecked={isChecked} state={agentRequest.home_phone} rules="num"/>
            </div>
          </div>

          <div className={agentRequestFieldClass}>
            <AgentRequestFieldLabel htmlFor="agent-email">{Dict('email')}</AgentRequestFieldLabel>
            <Input {...agentRequestInputProps}
                   id="agent-email"
                   value={agentRequest.email}
                   placeholder={Dict('email')}
                   onChange={(e) => {
                     setAgentRequest((prev) => ({
                       ...prev,
                       email: e.target.value,
                     }));
                   }}
            />
            <div className="flex flex-row">
              <Validator isChecked={isChecked} state={agentRequest.email} rules="required"/>
              <Validator isChecked={isChecked} state={agentRequest.email} rules="email"/>
            </div>
          </div>

          <div className={`${agentRequestFieldClass} md:col-span-2 xxl:col-span-3`}>
            <AgentRequestFieldLabel htmlFor="agent-address">{Dict('address')}</AgentRequestFieldLabel>
            <Textarea {...agentRequestInputProps}
                      id="agent-address"
                      value={agentRequest.address}
                      placeholder={Dict('address')}
                      onChange={(e) => {
                        setAgentRequest((prev) => ({
                          ...prev,
                          address: e.target.value,
                        }));
                      }}
            />
            <div className="flex flex-row mt-2">
              <Validator isChecked={isChecked} state={agentRequest.address} rules="required|alphanumeric"/>
            </div>
          </div>


        </div>
        <div className="mt-7 border-t border-app-border pt-4">
          <div className="flex flex-col gap-3 sm:flex-row sm:justify-between">
            <Button className={`w-full sm:w-auto ${agentRequestPrimaryButtonClass}`} onClick={save} disabled={isLastStep}>
              مرحله بعدی
            </Button>
            <Button variant="outlined" className={`w-full sm:w-auto ${agentRequestSecondaryButtonClass}`} onClick={() => {
              handlePrev(0)
            }} disabled={isFirstStep}>
              مرحله قبلی
            </Button>
          </div>
        </div>
      </>
    </ValidatorProvider>

  )
    ;
}
